import { Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import GaiaPageComponent from "~/modules/app/components/GaiaPageComponent";
import useCurrentUser from "~/modules/auth/hooks/useCurrentUser";

export default function DashboardFieldworkerAvailabilityRequired() {
    const { t } = useTranslation("app");
    const user = useCurrentUser();
    const navigate = useNavigate();

    return (
        <GaiaPageComponent
            title={t("dashboardComponents.dashboardFieldworkerAvailabilityRequired.title", {
                firstName: user!.firstName,
            })}
        >
            <Typography mb={5} variant="body1">
                {t("dashboardComponents.dashboardFieldworkerAvailabilityRequired.description")}
            </Typography>
            <Button variant="contained" onClick={() => navigate("/fieldworker/availability")}>
                {t("dashboardComponents.dashboardFieldworkerAvailabilityRequired.btnAvailability")}
            </Button>
        </GaiaPageComponent>
    );
}
